import { Grid, GridItem, Icon, Text } from "@innovationnorway/lighthouse-components";
import cn from "classnames";
import React from "react";
import { AccountTypeEnum } from "../../../../main/models/account-type-enum";
import { BREAKPOINT_ONETAB, BREAKPOINT_TWOTABS } from "../../../../utils/constants";
import useWindowSize from "../../../../utils/windowsSize";
import { useLayout } from "../../../hooks/useLayout";
import { ITabs } from "../../actorTabs/actorTabs";
import NotificationIcon from "../../notificationIcon/notificationIcon";
import { TabsDirection } from "../enums";
import "./tabsExpand.scss";

interface TabsExpandProps {
  hiddenTabs: ITabs[];
  moveTab: (t: ITabs, direction: TabsDirection) => void;
  findNotifications: (excludedTabs: ITabs[]) => number | undefined;
}

const TabsExpand = ({ hiddenTabs, moveTab, findNotifications }: TabsExpandProps) => {
  const { translations } = useLayout();
  const windowSize = useWindowSize();
  const showOneTab = windowSize.width < BREAKPOINT_ONETAB;
  const showTwoTabs = windowSize.width < BREAKPOINT_TWOTABS;
  return (
    <div className="Tabs__dropdown-menu">
      {hiddenTabs.map((t, i) => (
        <div
          key={`dropdown-tab-${i}`}
          className={cn("Tabs__dropdown-item", {
            "Tabs__dropdown-item-bookmarked": showTwoTabs ? (showOneTab ? i < 1 : i < 2) : i < 3
          })}
        >
          <Grid style={{ width: "100%" }}>
            <GridItem spanLarge={1} spanMedium={1} spanSmall={1} style={{ marginTop: "auto", marginBottom: "auto" }}>
              <NotificationIcon small notifications={findNotifications([t])} />
            </GridItem>
            <GridItem
              className="data-hj-suppress"
              spanLarge={4}
              spanMedium={4}
              spanSmall={1}
              style={{ marginTop: "auto", marginBottom: "auto" }}
            >
              <div className="Tabs__dropdown-small-item">
                {[AccountTypeEnum.NorwegianPerson, AccountTypeEnum.UnverifiedPerson].includes(t.accountType) && (
                  <Icon prefix="fasr" iconName="user" />
                )}
                {t.label}
              </div>
            </GridItem>
            <GridItem spanLarge={2} spanMedium={2} spanSmall={1} style={{ marginTop: "auto", marginBottom: "auto" }}>
              {i !== 0 && (
                <div
                  role="button"
                  className="Tabs__dropdown-small-item"
                  onClick={() => moveTab(t, TabsDirection.Backward)}
                  tabIndex={1}
                  onKeyUp={(e) => {
                    e.code === "Enter" && moveTab(t, TabsDirection.Backward);
                  }}
                >
                  <Icon className="Tabs__dropdown-icons" prefix="fasr" iconName="arrow-up" />
                  {translations.moveUp}
                </div>
              )}
            </GridItem>
            <GridItem
              spanLarge={2}
              spanMedium={2}
              spanSmall={1}
              style={{ marginTop: "auto", marginBottom: "auto" }}
              tabIndex={1}
              onKeyUp={(e) => {
                e.code === "Enter" && moveTab(t, TabsDirection.Forward);
              }}
            >
              {i !== hiddenTabs.length - 1 && (
                <div
                  role="button"
                  className="Tabs__dropdown-small-item"
                  onClick={() => moveTab(t, TabsDirection.Forward)}
                >
                  <Icon className="Tabs__dropdown-icons" prefix="fasr" iconName="arrow-down" />
                  {translations.moveDown}
                </div>
              )}
            </GridItem>
            <GridItem
              spanLarge={3}
              spanMedium={3}
              spanSmall={1}
              hideOnSmall
              style={{ marginTop: "auto", marginBottom: "auto" }}
            >
              <div className="Tabs__dropdown-small-item">
                {(showTwoTabs ? (showOneTab ? i < 1 : i < 2) : i < 3) ? (
                  <>
                    <Icon className="Tabs__dropdown-icons" prefix="fasr" iconName="bookmark" />
                    <Text>{translations.showBookmark}</Text>
                  </>
                ) : (
                  <>
                    <Icon className="Tabs__dropdown-icons" prefix="fasr" iconName="bookmark-slash" />
                    <Text>{translations.hideBookmark}</Text>
                  </>
                )}
              </div>
            </GridItem>
          </Grid>
        </div>
      ))}
    </div>
  );
};

export default TabsExpand;
